import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context";
import LoadingSpinner from "./LoadingSpinner";

interface ProtectedRouteProps {
  children: React.ReactNode;
}

const ProtectedRoute: React.FC<ProtectedRouteProps> = ({ children }) => {
  const { isAuthenticated, isLoading } = useAuth();

  if (isLoading) return <LoadingSpinner />;
  if (!isAuthenticated) return <Navigate to="/sign-up" replace />;

  return <>{children}</>;
};

export default ProtectedRoute;
